import { type Draft } from 'immer'
import { type BoardObjectsTransform, type IncludedResource } from './types'

const refKey = ({ type, id }: { type: string; id: string }) => `${type}:${id}`

/**
 * Append each resource that `included` does not already hold. Existing entries win. One pass over each list, so it
 * stays fast when a whole collection's includes are merged at once.
 */
export const mergeIncluded =
  (resources: IncludedResource[]): BoardObjectsTransform =>
  (draft) => {
    if (resources.length === 0) return draft
    if (!draft.included) draft.included = []

    const present = new Set(draft.included.map(refKey))
    resources.forEach((resource) => {
      const key = refKey(resource)
      if (present.has(key)) return
      present.add(key)
      draft.included!.push(resource as Draft<IncludedResource>)
    })
    return draft
  }
